module.exports = __webpack_public_path__ + "img/zcwj.6befe358.png";